var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomField',_vm._b({},'CustomField',_vm.$props,false),[_c('VueSelect',_vm._g(_vm._b({staticClass:"custom-select"},'VueSelect',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }